import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const SSO_CODE_KEY = "atease_sso_exchange_code";
const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
const ssoCode = hashParams.get("sso_code");

if (ssoCode) {
  try {
    sessionStorage.setItem(SSO_CODE_KEY, ssoCode);
  } catch {
    // The sign-in screen will show a generic failure if session storage is unavailable.
  }
}

const sensitiveHashParams = ["sso_code", "access_token", "user", "token", "session_id"];
const hadSensitiveHash = sensitiveHashParams.some((key) => hashParams.has(key));
sensitiveHashParams.forEach((key) => hashParams.delete(key));

if (hadSensitiveHash) {
  const remainingHash = hashParams.toString();
  window.history.replaceState(
    {},
    document.title,
    `${window.location.pathname}${window.location.search}${remainingHash ? `#${remainingHash}` : ""}`,
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
